// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__1b_kR","articleCancelSign":"Article_articleCancelSign__n13p2","inp":"Article_inp__1ZVwM"};